export const categoryList = [
  {
    name: "网红翻车",
    slug: "wanghong-fanche",
    icon: "ri-alert-line",
    description: "直击各大网红直播翻车现场，还原真相",
    color: "primary",
    articleCount: 1280,
  },
  {
    name: "独家爆料",
    slug: "dujia-baoliao",
    icon: "ri-spy-line",
    description: "吃瓜一线独家内幕，行业黑幕大揭秘",
    color: "accent",
    articleCount: 965,
  },
  {
    name: "娱乐八卦",
    slug: "yule-bagua",
    icon: "ri-chat-smile-2-line",
    description: "娱乐圈最新动态，明星八卦一站掌握",
    color: "primary",
    articleCount: 2340,
  },
  {
    name: "社会热点",
    slug: "shehui-redian",
    icon: "ri-fire-line",
    description: "全网最热社会话题，深度分析解读",
    color: "accent",
    articleCount: 1560,
  },
];

export interface CategoryArticle {
  slug: string;
  title: string;
  excerpt: string;
  imageUrl: string;
  date: string;
  readCount: number;
  hotIndex: number;
}

export const categoryArticles: Record<string, CategoryArticle[]> = {
  "wanghong-fanche": [
    {
      slug: "wanghong-fanche-zhibo-jianjia",
      title: "千万粉丝网红直播翻车：假货风波持续发酵，品牌方连夜解约",
      excerpt: "拥有超过两千万粉丝的头部带货主播\"小美酱\"在昨晚直播中被网友实锤售卖假冒名牌护肤品，涉事品牌已紧急发布声明终止合作。这是本月第三起头部主播翻车事件，引发全网热议。",
      imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20scene%20with%20a%20streaming%20studio%20setup%20featuring%20ring%20lights%20and%20a%20smartphone%20on%20a%20tripod%2C%20scattered%20luxury%20cosmetic%20products%20with%20red%20warning%20elements%2C%20dark%20and%20tense%20atmosphere%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20editorial%20photojournalism%20style%2C%20high%20contrast%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20moody%20investigative%20aesthetic&width=800&height=560&seq=cat-wf-01&orientation=landscape",
      date: "2026-07-07",
      readCount: 1283000,
      hotIndex: 98,
    },
    {
      slug: "wangluo-hongren-beipan",
      title: "网络红人被曝背后有资本操控，人设全面崩塌",
      excerpt: "一份内部文件曝光，揭示了该网红\"草根逆袭\"人设背后的资本运作真相。多家投资机构被点名，网友直呼上当受骗。",
      imageUrl: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20office%20with%20documents%20scattered%20on%20a%20glass%20desk%2C%20a%20laptop%20screen%20glowing%20with%20data%20charts%2C%20dramatic%20side%20lighting%20casting%20long%20shadows%2C%20mysterious%20and%20investigative%20mood%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20documentary%20photography%20style%2C%20cinematic%20composition&width=800&height=560&seq=cat-wf-02&orientation=landscape",
      date: "2026-07-04",
      readCount: 1210000,
      hotIndex: 82,
    },
    {
      slug: "meizhuang-bozhu-chanpin",
      title: "美妆博主推荐产品被曝含违禁成分，粉丝集体维权",
      excerpt: "一位拥有五百万粉丝的美妆博主推荐的祛痘产品被检测出含有违禁激素成分，目前已有多位粉丝出现过敏反应并联合发起维权。",
      imageUrl: "https://readdy.ai/api/search-image?query=Skincare%20products%20arranged%20on%20a%20white%20marble%20surface%20with%20a%20warning%20label%20visible%2C%20laboratory%20testing%20equipment%20in%20soft%20focus%20background%2C%20clinical%20aesthetic%20with%20cool%20white%20and%20red%20accent%20tones%2C%20product%20safety%20investigation%20theme%2C%20editorial%20product%20photography%20with%20dramatic%20side%20lighting&width=800&height=560&seq=cat-wf-03&orientation=landscape",
      date: "2026-07-02",
      readCount: 987000,
      hotIndex: 79,
    },
    {
      slug: "daihuo-yige-baofa",
      title: "直播带货界大地震：多位大主播集体翻车",
      excerpt: "消费者协会发布最新检测报告，多款直播间热销产品被曝质量问题严重。涉及虚假宣传、以次充好等问题，行业信任危机加剧。",
      imageUrl: "https://readdy.ai/api/search-image?query=Multiple%20smartphones%20displaying%20live%20streaming%20interfaces%20with%20shopping%20carts%2C%20arranged%20in%20a%20grid%20pattern%2C%20warning%20red%20accents%20on%20some%20screens%2C%20clean%20minimalist%20product%20photography%20style%2C%20soft%20diffused%20lighting%20from%20above%2C%20white%20and%20warm%20gray%20background%20with%20subtle%20red%20highlights&width=800&height=560&seq=cat-wf-04&orientation=landscape",
      date: "2026-07-05",
      readCount: 1523000,
      hotIndex: 88,
    },
    {
      slug: "shipin-bozhu-juben",
      title: "美食博主被曝剧本造假，\"偶遇\"全是精心设计",
      excerpt: "一位以街头美食探店走红的博主被同行爆料，其所有节目都有详细剧本和演员安排，所谓的\"随机路人\"都是提前安排好的群演。",
      imageUrl: "https://readdy.ai/api/search-image?query=Street%20food%20market%20scene%20with%20camera%20equipment%20visible%20in%20reflection%2C%20a%20script%20document%20lying%20on%20a%20nearby%20table%2C%20warm%20evening%20lighting%20with%20string%20lights%2C%20candid%20documentary%20style%20with%20slightly%20desaturated%20tones%2C%20revealing%20the%20behind-the-scenes%20reality%20aesthetic&width=800&height=560&seq=cat-wf-05&orientation=landscape",
      date: "2026-06-28",
      readCount: 756000,
      hotIndex: 75,
    },
    {
      slug: "yundong-bozhu-xuwei",
      title: "运动博主被指虚假人设，\"健身达人\"实为药物辅助",
      excerpt: "某知名健身博主被前教练爆料，其完美的肌肉线条并非靠自然训练达成，而是长期依赖药物，所谓\"三个月逆袭\"教程纯属欺骗消费者。",
      imageUrl: "https://readdy.ai/api/search-image?query=Gym%20interior%20with%20weights%20and%20equipment%2C%20a%20medicine%20bottle%20subtly%20placed%20on%20a%20bench%2C%20dramatic%20overhead%20lighting%20creating%20strong%20shadows%2C%20fitness%20and%20controversy%20theme%2C%20warm%20industrial%20tones%20with%20red%20accent%20lighting%2C%20investigative%20sports%20documentary%20aesthetic&width=800&height=560&seq=cat-wf-06&orientation=landscape",
      date: "2026-06-25",
      readCount: 892000,
      hotIndex: 72,
    },
  ],
  "dujia-baoliao": [
    {
      slug: "yingshi-juxing-beiju",
      title: "影视巨星被曝片场耍大牌，导演愤然离场",
      excerpt: "据知情人士透露，该明星在拍摄现场多次迟到，还要求修改剧本，导致导演当场发飙。制片方已紧急开会讨论是否更换主演。",
      imageUrl: "https://readdy.ai/api/search-image?query=Film%20set%20environment%20with%20professional%20camera%20equipment%20and%20director%20chair%20empty%20in%20foreground%2C%20dramatic%20lighting%20rig%20overhead%2C%20tense%20atmosphere%20with%20warm%20cinematic%20lighting%2C%20clapperboard%20on%20the%20ground%20symbolizing%20disruption%2C%20behind%20the%20scenes%20documentary%20aesthetic&width=800&height=560&seq=cat-dj-01&orientation=landscape",
      date: "2026-07-05",
      readCount: 1345000,
      hotIndex: 85,
    },
    {
      slug: "yule-gongsi-neimu",
      title: "某知名娱乐公司内部邮件曝光，艺人合同暗藏陷阱",
      excerpt: "一封内部邮件显示，某大型娱乐经纪公司与旗下艺人的合同中存在大量不公平条款，艺人收入被层层盘剥，实际到手不足10%。",
      imageUrl: "https://readdy.ai/api/search-image?query=Corporate%20office%20at%20night%20with%20confidential%20documents%20spread%20across%20a%20desk%2C%20a%20computer%20screen%20glowing%20in%20the%20dark%2C%20dramatic%20single%20light%20source%20creating%20noir%20atmosphere%2C%20business%20secrets%20investigation%20theme%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20cinematic%20thriller%20aesthetic&width=800&height=560&seq=cat-dj-02&orientation=landscape",
      date: "2026-07-03",
      readCount: 1102000,
      hotIndex: 83,
    },
    {
      slug: "xuanxiu-jie-muhou",
      title: "选秀节目幕后黑幕：投票数据涉嫌大规模造假",
      excerpt: "前节目组工作人员匿名爆料，某热门选秀节目的观众投票环节存在系统性数据造假，实际排名与播出结果严重不符。",
      imageUrl: "https://readdy.ai/api/search-image?query=TV%20studio%20control%20room%20with%20multiple%20monitor%20screens%20showing%20voting%20data%2C%20a%20person%20in%20shadow%20pointing%20at%20screens%2C%20tense%20atmosphere%20with%20blue%20and%20red%20indicator%20lights%2C%20behind-the-scenes%20television%20production%20aesthetic%2C%20documentary%20style%20with%20high%20contrast%20lighting&width=800&height=560&seq=cat-dj-03&orientation=landscape",
      date: "2026-06-30",
      readCount: 1456000,
      hotIndex: 87,
    },
    {
      slug: "yinyue-banquan-zhengyi",
      title: "音乐版权纠纷升级：顶流歌手新歌涉嫌抄袭海外作品",
      excerpt: "音乐制作人实名举报某顶流歌手最新单曲抄袭一首三年前发行的海外独立音乐人作品，目前两首歌曲的对比视频已在网络疯传。",
      imageUrl: "https://readdy.ai/api/search-image?query=Music%20studio%20with%20mixing%20console%20and%20computer%20screens%20showing%20audio%20waveforms%20side%20by%20side%20for%20comparison%2C%20dramatic%20lighting%20with%20red%20and%20blue%20contrast%2C%20copyright%20investigation%20theme%2C%20professional%20audio%20production%20aesthetic%20with%20cinematic%20shadows&width=800&height=560&seq=cat-dj-04&orientation=landscape",
      date: "2026-06-28",
      readCount: 987000,
      hotIndex: 80,
    },
    {
      slug: "zongyi-jie-heiyue",
      title: "综艺界\"潜规则\"曝光：嘉宾出场费差距达百倍",
      excerpt: "一份综艺节目制作预算表流出，揭示了同档节目中不同嘉宾出场费的巨大差距，部分流量明星单集片酬高达八位数。",
      imageUrl: "https://readdy.ai/api/search-image?query=Financial%20spreadsheet%20document%20on%20a%20desk%20with%20a%20magnifying%20glass%20highlighting%20numbers%2C%20television%20studio%20lights%20blurred%20in%20background%2C%20dramatic%20contrast%20between%20warm%20studio%20glow%20and%20cool%20office%20lighting%2C%20investigative%20journalism%20theme%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field&width=800&height=560&seq=cat-dj-05&orientation=landscape",
      date: "2026-06-24",
      readCount: 823000,
      hotIndex: 76,
    },
    {
      slug: "guanggao-daiyan-neiqing",
      title: "广告代言内幕：明星代言费与产品效果完全无关",
      excerpt: "业内人士揭秘明星代言产业链，揭露大部分明星在接代言前根本不使用产品，所谓的\"亲测有效\"全是营销话术。",
      imageUrl: "https://readdy.ai/api/search-image?query=Advertising%20photoshoot%20set%20with%20bright%20studio%20lights%20and%20a%20model%20posing%20with%20a%20product%2C%20contract%20papers%20visible%20on%20a%20side%20table%2C%20behind-the-scenes%20commercial%20production%20aesthetic%2C%20clean%20white%20studio%20with%20warm%20accent%20lighting%2C%20documentary%20style%20revealing%20the%20production%20reality&width=800&height=560&seq=cat-dj-06&orientation=landscape",
      date: "2026-06-20",
      readCount: 1054000,
      hotIndex: 78,
    },
  ],
  "yule-bagua": [
    {
      slug: "danghong-nanyixing-chugui",
      title: "当红男星深夜密会神秘女子，疑似婚内出轨",
      excerpt: "某知名男演员被拍到与一名年轻女子在酒店共度三小时，其经纪团队尚未回应。网友扒出该女子身份疑似某网红。",
      imageUrl: "https://readdy.ai/api/search-image?query=Paparazzi%20style%20night%20photography%20of%20a%20luxury%20hotel%20entrance%20at%20night%20with%20subtle%20silhouettes%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20warm%20street%20lights%20reflecting%20on%20wet%20pavement%2C%20cinematic%20noir%20aesthetic%2C%20soft%20bokeh%20background%2C%20deep%20blues%20and%20amber%20tones%2C%20editorial%20gossip%20magazine%20vibe&width=800&height=560&seq=cat-yl-01&orientation=landscape",
      date: "2026-07-07",
      readCount: 2456000,
      hotIndex: 98,
    },
    {
      slug: "nvtuanti-yuan-neihong",
      title: "女团成员直播互撕，队内矛盾全面爆发",
      excerpt: "某当红女团两名成员在直播中公开争吵，互相指责对方耍大牌、抢资源。经纪公司紧急叫停直播，但视频已被网友录屏疯传。",
      imageUrl: "https://readdy.ai/api/search-image?query=Split%20screen%20vibe%20with%20two%20contrasting%20sides%2C%20one%20side%20bright%20stage%20lights%20and%20glamorous%20atmosphere%2C%20other%20side%20dark%20backstage%20tension%2C%20music%20performance%20elements%20like%20microphones%20and%20spotlights%2C%20dramatic%20color%20contrast%20between%20warm%20gold%20and%20cool%20shadow%2C%20editorial%20entertainment%20news%20aesthetic&width=800&height=560&seq=cat-yl-02&orientation=landscape",
      date: "2026-07-06",
      readCount: 1765000,
      hotIndex: 91,
    },
    {
      slug: "yule-quan-xinren",
      title: "娱乐圈新人被曝与经纪人恋爱，公司称系正常交往",
      excerpt: "一位刚出道不满一年的新生代演员被拍到与经纪人牵手逛街，引发粉丝热议。有人祝福，也有人质疑经纪人利用职务之便。",
      imageUrl: "https://readdy.ai/api/search-image?query=Shopping%20street%20daytime%20scene%20with%20two%20people%20walking%20hand%20in%20hand%20in%20soft%20focus%2C%20paparazzi%20style%20candid%20photography%2C%20warm%20natural%20sunlight%20through%20trees%20creating%20dappled%20light%2C%20romantic%20but%20discreet%20atmosphere%2C%20editorial%20entertainment%20magazine%20candid%20shot%20with%20warm%20tones&width=800&height=560&seq=cat-yl-03&orientation=landscape",
      date: "2026-07-01",
      readCount: 1345000,
      hotIndex: 84,
    },
    {
      slug: "laopai-yanyuan-fuqi",
      title: "老牌演员夫妻被传婚变，双方工作室同时辟谣",
      excerpt: "结婚二十年的演艺圈模范夫妻被传已分居半年，双方工作室几乎同时发布声明否认，但网友发现两人已数月未同框。",
      imageUrl: "https://readdy.ai/api/search-image?query=Two%20separate%20luxury%20apartments%20shown%20in%20split%20composition%2C%20each%20with%20different%20interior%20style%2C%20elegant%20but%20lonely%20atmosphere%2C%20warm%20evening%20lighting%20through%20large%20windows%2C%20cinematic%20split-screen%20aesthetic%2C%20soft%20golden%20hour%20tones%20with%20subtle%20melancholic%20mood&width=800&height=560&seq=cat-yl-04&orientation=landscape",
      date: "2026-06-29",
      readCount: 1890000,
      hotIndex: 89,
    },
    {
      slug: "liuliang-xiaosheng-lianai",
      title: "流量小生被曝与女粉丝秘密恋爱，后援会集体脱粉",
      excerpt: "一位拥有千万粉丝的年轻男星被曝与一名女粉丝维持了长达一年的秘密恋情，后援会核心成员集体宣布脱粉并关闭应援站。",
      imageUrl: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20social%20media%20fan%20page%20notifications%20with%20declining%20numbers%2C%20a%20coffee%20cup%20and%20concert%20ticket%20stub%20nearby%2C%20emotional%20moment%20captured%20in%20warm%20ambient%20lighting%2C%20bittersweet%20fan%20culture%20theme%2C%20soft%20bokeh%20background%20with%20warm%20golden%20tones&width=800&height=560&seq=cat-yl-05&orientation=landscape",
      date: "2026-06-26",
      readCount: 2100000,
      hotIndex: 92,
    },
    {
      slug: "yingshi-quan-eryu",
      title: "影视圈\"二世祖\"被曝靠父母资源上位，实力遭质疑",
      excerpt: "多位业内人士匿名评价某\"星二代\"演员，称其演技平庸却能拿到顶级资源，全靠父母在圈内的人脉运作。",
      imageUrl: "https://readdy.ai/api/search-image?query=Film%20set%20with%20a%20young%20actor%20standing%20in%20spotlight%20while%20older%20figures%20in%20suits%20stand%20in%20shadows%20behind%2C%20dramatic%20theatrical%20lighting%20with%20strong%20contrast%2C%20nepotism%20and%20power%20dynamics%20theme%2C%20cinematic%20composition%20with%20chiaroscuro%20lighting%2C%20warm%20spot%20and%20cool%20shadow%20tones&width=800&height=560&seq=cat-yl-06&orientation=landscape",
      date: "2026-06-22",
      readCount: 1670000,
      hotIndex: 86,
    },
  ],
  "shehui-redian": [
    {
      slug: "zhiming-zhubo-taoshui",
      title: "知名主播被曝偷税漏税，金额高达数千万",
      excerpt: "税务部门已介入调查，该主播名下多家公司被列入经营异常名录。据悉，其通过设立空壳公司、阴阳合同等方式逃避个人所得税。",
      imageUrl: "https://readdy.ai/api/search-image?query=Corporate%20office%20scene%20with%20financial%20documents%20and%20a%20calculator%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20overhead%20lighting%20creating%20harsh%20shadows%2C%20red%20seal%20stamps%20visible%20on%20papers%2C%20tense%20investigative%20mood%2C%20warm%20and%20cool%20color%20contrast%2C%20documentary%20style%20photography%2C%20high%20detail&width=800&height=560&seq=cat-sh-01&orientation=landscape",
      date: "2026-07-06",
      readCount: 1987000,
      hotIndex: 95,
    },
    {
      slug: "xuanxiu-guanjun-xueli",
      title: "某选秀冠军被曝学历造假，\"名校光环\"实为包装",
      excerpt: "网友发现某选秀节目冠军在节目中声称的国外名校学历实为短期培训课程，其海外求学经历多处存在疑点。",
      imageUrl: "https://readdy.ai/api/search-image?query=University%20campus%20library%20with%20a%20diploma%20certificate%20on%20a%20table%20being%20examined%20through%20a%20magnifying%20glass%2C%20academic%20investigation%20theme%2C%20warm%20library%20lighting%20with%20afternoon%20sun%20through%20tall%20windows%2C%20scholarly%20atmosphere%20with%20subtle%20tension%2C%20documentary%20educational%20aesthetic&width=800&height=560&seq=cat-sh-02&orientation=landscape",
      date: "2026-07-03",
      readCount: 1432000,
      hotIndex: 88,
    },
    {
      slug: "wangluo-baoli-shaonian",
      title: "网络暴力致未成年人抑郁，涉事网红账号被永久封禁",
      excerpt: "一名十四岁少年因在网络平台被某网红粉丝集体围攻，被诊断出重度抑郁。平台方已对涉事网红账号作出永久封禁处理。",
      imageUrl: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20social%20media%20with%20harsh%20comment%20notifications%2C%20placed%20on%20a%20windowsill%20with%20rain%20drops%20on%20glass%2C%20melancholic%20and%20somber%20atmosphere%2C%20cool%20blue-gray%20tones%20with%20soft%20natural%20window%20light%2C%20emotional%20social%20commentary%20theme%2C%20cinematic%20still%20life%20composition&width=800&height=560&seq=cat-sh-03&orientation=landscape",
      date: "2026-06-30",
      readCount: 2345000,
      hotIndex: 94,
    },
    {
      slug: "AI-huannian-jishu",
      title: "AI换脸技术被用于制作虚假名人视频，法律空白引担忧",
      excerpt: "近期网络上出现大量利用AI换脸技术制作的虚假名人视频，涉及多位演艺明星和公众人物。专家呼吁加快相关立法。",
      imageUrl: "https://readdy.ai/api/search-image?query=Computer%20screen%20showing%20facial%20recognition%20and%20deepfake%20technology%20interface%20with%20split%20face%20comparison%2C%20dark%20room%20with%20only%20monitor%20glow%2C%20futuristic%20and%20unsettling%20atmosphere%2C%20cool%20blue%20digital%20tones%20with%20warm%20skin%20tone%20contrast%2C%20technology%20ethics%20theme%2C%20cinematic%20cyberpunk%20aesthetic&width=800&height=560&seq=cat-sh-04&orientation=landscape",
      date: "2026-06-27",
      readCount: 1876000,
      hotIndex: 90,
    },
    {
      slug: "zhubo-cishan-jiema",
      title: "主播慈善直播被指作秀，捐款凭证经查系伪造",
      excerpt: "某主播在直播间宣称为灾区捐款百万元并出示捐款凭证，后被网友发现凭证为PS伪造。慈善机构也确认未收到该笔款项。",
      imageUrl: "https://readdy.ai/api/search-image?query=Charity%20donation%20certificate%20document%20on%20a%20desk%20with%20a%20red%20FAKE%20stamp%20overlay%2C%20dramatic%20lighting%20from%20a%20desk%20lamp%20creating%20harsh%20shadows%2C%20investigation%20and%20fraud%20theme%2C%20warm%20amber%20desk%20light%20against%20cool%20room%20darkness%2C%20documentary%20crime%20scene%20aesthetic&width=800&height=560&seq=cat-sh-05&orientation=landscape",
      date: "2026-06-23",
      readCount: 1567000,
      hotIndex: 85,
    },
    {
      slug: "duan-shipin-chenmi",
      title: "短视频沉迷问题引两会关注，代表建议实施分级管理",
      excerpt: "多位全国人大代表提交关于短视频平台内容分级管理的提案，建议对未成年人使用短视频实施时长限制和内容过滤。",
      imageUrl: "https://readdy.ai/api/search-image?query=Government%20meeting%20room%20with%20a%20large%20screen%20displaying%20social%20media%20statistics%20and%20graphs%2C%20formal%20atmosphere%20with%20warm%20wood%20tones%20and%20natural%20light%20from%20windows%2C%20policy%20discussion%20theme%2C%20professional%20documentary%20photography%20style%2C%20balanced%20composition%20with%20institutional%20aesthetic&width=800&height=560&seq=cat-sh-06&orientation=landscape",
      date: "2026-06-20",
      readCount: 1234000,
      hotIndex: 81,
    },
  ],
};

export const categoryMeta: Record<string, {
  title: string;
  description: string;
  keywords: string;
  imageUrl: string;
}> = {
  "wanghong-fanche": {
    title: "网红翻车 - 吃瓜51网 | 直播翻车现场 · 网红人设崩塌 · 带货虚假宣传",
    description: "吃瓜51网网红翻车频道，每日更新最新网红直播翻车现场、网红人设崩塌事件与带货虚假宣传内幕。直击第一现场，还原真实真相，全网最全网红翻车合集。",
    keywords: "网红翻车,直播翻车,网红人设崩塌,带货虚假宣传,网红黑料,吃瓜51网",
    imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20streaming%20studio%20scene%20with%20multiple%20ring%20lights%20and%20smartphones%2C%20some%20screens%20showing%20warning%20and%20error%20symbols%2C%20scattered%20luxury%20products%20with%20caution%20tape%2C%20cinematic%20lighting%20with%20strong%20red%20and%20amber%20tones%2C%20dark%20moody%20background%2C%20editorial%20breaking%20news%20aesthetic%2C%20high%20contrast%20dramatic%20shadows&width=1600&height=600&seq=cat-header-wf&orientation=landscape",
  },
  "dujia-baoliao": {
    title: "独家爆料 - 吃瓜51网 | 娱乐圈内幕 · 行业黑幕 · 一手猛料",
    description: "吃瓜51网独家爆料频道，为你带来娱乐圈内幕消息、行业黑幕揭秘与一手猛料。匿名爆料人、内部文件、线人消息，吃瓜第一线独家报道。",
    keywords: "独家爆料,娱乐圈内幕,行业黑幕,一手猛料,匿名爆料,吃瓜51网",
    imageUrl: "https://readdy.ai/api/search-image?query=Mysterious%20investigative%20journalism%20scene%20with%20confidential%20documents%20under%20a%20desk%20lamp%2C%20a%20voice%20recorder%20and%20camera%20on%20the%20table%2C%20shadows%20and%20dramatic%20lighting%2C%20noir%20film%20aesthetic%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field%2C%20secret%20investigation%20theme&width=1600&height=600&seq=cat-header-dj&orientation=landscape",
  },
  "yule-bagua": {
    title: "娱乐八卦 - 吃瓜51网 | 明星动态 · 恋情曝光 · 娱乐圈趣闻",
    description: "吃瓜51网娱乐八卦频道，聚焦明星最新动态、明星恋情曝光、娱乐圈趣闻轶事。八卦爱好者的一站式娱乐资讯平台，每日更新不容错过。",
    keywords: "娱乐八卦,明星动态,明星恋情,娱乐圈趣闻,八卦新闻,吃瓜51网",
    imageUrl: "https://readdy.ai/api/search-image?query=Glamorous%20red%20carpet%20event%20scene%20with%20camera%20flashes%20and%20velvet%20ropes%2C%20celebrity%20silhouettes%20against%20bright%20spotlights%2C%20paparazzi%20photography%20atmosphere%2C%20warm%20golden%20and%20magenta%20tones%2C%20entertainment%20industry%20glamour%20with%20dramatic%20lighting%2C%20editorial%20fashion%20magazine%20aesthetic&width=1600&height=600&seq=cat-header-yl&orientation=landscape",
  },
  "shehui-redian": {
    title: "社会热点 - 吃瓜51网 | 网络热点 · 社会话题 · 深度观察",
    description: "吃瓜51网社会热点频道，深度解读全网最热社会话题。从网络热点事件到社会现象分析，从娱乐衍生到民生关注，全方位覆盖热点资讯。",
    keywords: "社会热点,网络热点,社会话题,热点新闻,深度观察,吃瓜51网",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20multiple%20large%20screens%20displaying%20social%20media%20trending%20topics%20and%20news%20headlines%2C%20bustling%20atmosphere%20with%20warm%20ambient%20lighting%2C%20professional%20journalism%20environment%2C%20clean%20contemporary%20aesthetic%20with%20red%20accent%20elements%2C%20documentary%20photography%20style%20with%20natural%20depth%20of%20field&width=1600&height=600&seq=cat-header-sh&orientation=landscape",
  },
};